import React, { memo } from "react";
import classNames from "classnames";
import { NavLink } from "react-router-dom";
import { translate } from "lib";
import icons from "v2/utils/icon";

const Link = ({
	href,
	label,
	className,
	hideLabel,
	beta,
	badge,
	children
}: {
	href: string;
	label?: string;
	className?: string;
	hideLabel?: boolean;
	beta?: boolean;
	/**
	 * Rendered INLINE beside the label, inside the label's own row. Anything
	 * placed under the label instead would grow this column and, because the
	 * link is `h-20 justify-center`, push the icon and label out of line with
	 * every other item in the nav.
	 */
	badge?: React.ReactNode;
	children?: React.ReactNode;
}) => {
	return (
		<NavLink
			to={href}
			className={classNames(
				"hover:bg-transparent text-black-60 hover:text-blue-100",
				"relative",
				"px-3 h-20 flex flex-col justify-center items-center border-transparent hover:border-blue-100 border-b-3",
				className
			)}
			activeClassName="bg-transparent border-blue-100 text-blue-100"
			exact
		>
			{label && icons(label)}
			{!hideLabel && label && (
				<div className="text-12 font-mont mt-1 flex items-center whitespace-no-wrap">
					{translate(label)}
					{badge}
				</div>
			)}
			{children}
			{beta && (
				<div className=" text-11 absolute w-11 h-5 leading-5 rounded-3 bg-error-darker text-center text-white top-2px right-0">
					Beta
				</div>
			)}
		</NavLink>
	);
};

export default memo(Link);
